// DEV-849 (эпик DEV-842). Строки async-состояний AppSearchableSelect.

const ruSearchableSelect = {
  loading: 'Загрузка…',
  minChars: 'Введите минимум {count} символа',
  empty: 'Ничего не найдено',
  error: 'Не удалось загрузить список',
  retry: 'Повторить',
  custom: 'Указать вручную: «{query}»',
  placeholder: 'Выберите значение',
  clear: 'Очистить',
}

const enSearchableSelect = {
  loading: 'Loading…',
  minChars: 'Type at least {count} characters',
  empty: 'Nothing found',
  error: 'Failed to load the list',
  retry: 'Retry',
  custom: 'Enter manually: “{query}”',
  placeholder: 'Select…',
  clear: 'Clear',
}

const vnSearchableSelect = {
  loading: 'Đang tải…',
  minChars: 'Nhập ít nhất {count} ký tự',
  empty: 'Không tìm thấy',
  error: 'Không tải được danh sách',
  retry: 'Thử lại',
  custom: 'Nhập thủ công: “{query}”',
  placeholder: 'Chọn giá trị',
  clear: 'Xóa',
}

export const dev842Messages = {
  ru: { designSystem: { searchableSelect: ruSearchableSelect } },
  en: { designSystem: { searchableSelect: enSearchableSelect } },
  vn: { designSystem: { searchableSelect: vnSearchableSelect } },
}
